module.exports = __webpack_public_path__ + "dd5003c60480d12f3c6778fb4d5fc26c.svg";